import PropTypes from 'prop-types';

export default function AltText(props) {
  const { Element = 'p', children, className } = props;

  return (
    <Element
      className={`font-mono text-[0.625rem] font-normal leading-[0.888rem] tracking-[0.04em] lg:text-[1rem] lg:leading-[1.243rem] ${className}`}
    >
      {children}
    </Element>
  );
}

AltText.propTypes = {
  className: PropTypes.string,
  Element: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'p']),
  children: PropTypes.node.isRequired,
};
